import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticlePreview() {
  return (
    <section className="py-24 md:py-32 bg-background-200/70">
      <div className="px-6 md:px-10 max-w-[1300px] mx-auto">
        <div className="mb-14">
          <span className="inline-block px-4 py-1.5 bg-background-100 text-foreground-700 text-xs font-medium rounded-full whitespace-nowrap">
            Блог и гайды
          </span>
          <h2 className="mt-4 text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            Всё о покупках из Китая
            <br />
            через Spreadsheet системы
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <article
              key={article.id}
              className="bg-background-50 rounded-2xl overflow-hidden flex flex-col group hover:bg-background-100 transition-colors"
            >
              <div className="aspect-[16/10] w-full overflow-hidden">
                <img
                  src={article.imgSrc}
                  alt={article.title}
                  title={`${article.title} — yoybuy spreadsheet`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5 md:p-6 flex-1 flex flex-col">
                <div className="flex items-start gap-3 mb-3">
                  <div className="w-9 h-9 rounded-full bg-background-200/70 flex items-center justify-center flex-shrink-0">
                    <i className={`${article.icon} text-base text-foreground-700 w-4 h-4 flex items-center justify-center`}></i>
                  </div>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-950 leading-snug">
                    {article.title}
                  </h3>
                </div>

                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed flex-1 line-clamp-3">
                  {article.excerpt}
                </p>

                <Link
                  to={`/guide/${article.slug}`}
                  className="inline-flex items-center gap-1.5 mt-4 text-xs md:text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors cursor-pointer whitespace-nowrap"
                >
                  <span>Читать полностью</span>
                  <i className="ri-arrow-right-line text-xs w-3 h-3 flex items-center justify-center"></i>
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}